export default {
    computed: {
        weightSettings() {
            return {
                unit: 'kg',
                separator: ',',
            }
        }
    },
    methods: {
        formatWeight(
            value,
            unit = this.weightSettings.unit,
            separator = this.weightSettings.separator
        ) {
            if (isNaN(value) || value === null) {
                return '-'
            }
            const weight = value.toString().replace('.', separator)

            return weight ? (unit === false ? weight : `${weight} ${unit}` ) : '-'
        },
        unformatWeight(value, separator = this.weightSettings.separator) {
            if (!value) {
                return false
            }

            return parseFloat(value.replace(separator, '.'))
        },
        roundWeight(number, precision = 1000) {
            if (!isNaN(number) && number !== null) {
                return Math.round(number * precision) / precision
            }
            
            return '-'
        }
    }
}
